// extracted by mini-css-extract-plugin
export var bounce = "styles-module--bounce--06a4d";
export var container = "styles-module--container--634da";
export var pulse = "styles-module--pulse--e86e1";
export var section = "styles-module--section--8596e";